var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78258 1.27319C4.78667 1.27068 4.79075 1.26818 4.79484 1.26567L6.88599 3.35683C6.88181 3.35923 6.87763 3.36165 6.87345 3.36406L8.24941 4.74002C8.25429 4.7383 8.25917 4.73659 8.26405 4.73489L11.7651 8.23595C11.7634 8.24083 11.7617 8.24571 11.76 8.25059L13.1359 9.62655C13.1384 9.62237 13.1408 9.61819 13.1432 9.61401L15.4288 11.8997C15.4255 11.903 15.4222 11.9063 15.419 11.9096L16.0933 12.5839C16.4513 12.9419 16.4513 13.5223 16.0933 13.8803C15.7353 14.2383 15.1549 14.2383 14.797 13.8803L14.0097 13.093C12.5674 14.0971 10.9183 14.6667 9.16667 14.6667C5.15702 14.6667 1.685 11.6823 0 7.33334C0.768755 5.3492 1.90948 3.64909 3.30352 2.38685L2.48151 1.56485C2.12353 1.20687 2.12353 0.626466 2.48151 0.268485C2.8395 -0.0894951 3.4199 -0.0894951 3.77788 0.268485L4.78258 1.27319ZM5.49981 4.58314C4.92434 5.3492 4.58333 6.30144 4.58333 7.33333C4.58333 9.86464 6.63536 11.9167 9.16667 11.9167C10.1986 11.9167 11.1508 11.5757 11.9169 11.0002L10.5984 9.68171C10.1813 9.93651 9.69115 10.0833 9.16667 10.0833C7.64788 10.0833 6.41667 8.85212 6.41667 7.33333C6.41667 6.80885 6.5635 6.31866 6.81829 5.90162L5.49981 4.58314Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.33333C13.75 7.42939 13.747 7.52475 13.7412 7.61933L16.6214 10.4995C17.304 9.56242 17.8826 8.4967 18.3333 7.33334C16.6483 2.98439 13.1763 0 9.16667 0C8.26467 0 7.38988 0.151026 6.55653 0.434637L8.88067 2.75878C8.97525 2.75295 9.07061 2.75 9.16667 2.75C11.698 2.75 13.75 4.80203 13.75 7.33333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/EyeSlash.f0f106ade8372494c5591cda74eac66e.svg";
export { ForwardRef as ReactComponent };